import React from 'react'
import ClientDetailsReport from './ClientDetailsReport'
import { useStateContext } from '../context/StateContext';
import DeviceFamilyReport from './DeviceFamilyReport';
import { set } from 'lodash';

/**
 * RegisterInfo component
 * #registers
 * This component is used to display the information related to a register.
 * It receives the register, devices, deviceNonConformities, registerTemplate, and setRegisterInfo as props.
 * 
 * @param {Object} register - The register object
 * @param {Function} setRegisterInfo - The function to set the register info state
 * @param {Array} devices - The devices array
 * @param {Array} deviceNonConformities - The deviceNonConformities array
 * @param {Object} registerTemplate - The register template object
 */
const RegisterInfo = ({register, setRegisterInfo, devices, deviceNonConformities, registerTemplate}) => {
    const {client} = useStateContext();
    
    const testFunction = () => {
        console.log("SITE INFO TEST", devices, deviceNonConformities)
    }
    const filteredDeviceNonConformities = deviceNonConformities
    ?.filter?.((x)=>{return x?.register?._ref == register?._id})
    ?.filter?.((y)=> {
      const findDevice = register?.devices?.find?.((x)=>x?._id == y?.device?._ref)
      //console.log("kdoskposdk",{findDevice, devices, y} )
      if(findDevice?.status == "ARCHIVIATO") return 
      return y
    })
    const registerDetails = {
        devices: devices?.filter?.((x)=>x?.register?._ref == register?._id),
        deviceNonConformities: filteredDeviceNonConformities, 
        hideLegenda: true, 
        hideClientsAndSites: true,
        //showToSupply: true,
        register,
        registerTemplate,
        client
    }
  return (
    <div>
        <h2 onClick={testFunction}>INFORMAZIONI REGISTRO</h2>
        <ClientDetailsReport data = {registerDetails}/>
        <DeviceFamilyReport register = {register} registerTemplate = {registerTemplate} />
          <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <button onClick={()=>setRegisterInfo(false)} className='pdf-button'>
                CHIUDI INFORMAZIONI REGISTRO
            </button>
        </div>
    </div>
  )
}

export default RegisterInfo
